/**
 * quizSensibilisation.js — Quiz d'ancrage Permis AM · Module 3 Sensibilisation
 * 10 QCM pédagogiques rédigés à partir des 15 sections du module.
 * Format : { q, choices[4], answer (0-3), explain }
 * Public : élèves AM (+ parents/représentants légaux présents pour les mineurs).
 */
export const quiz = {
  id: 'permis-am-sensibilisation',
  title: "Quiz d'ancrage · Module 3 Sensibilisation",
  color: '#f59e0b',
  cours: '/cours/permis-am-sensibilisation',
  questions: [
    {
      q: "Pourquoi un conducteur de cyclomoteur est-il plus vulnérable qu'un automobiliste ?",
      choices: [
        "Parce qu'il roule moins vite",
        "Parce qu'il n'a pas de carrosserie, ceinture ni airbags autour de lui",
        "Parce qu'il n'a pas de permis",
        "Parce qu'il n'a pas d'assurance",
      ],
      answer: 1,
      explain: "Sur un deux-roues, le corps est directement exposé. Aucune structure ne s'interpose entre toi et un choc éventuel — d'où l'importance d'observer, anticiper et conserver une marge.",
    },
    {
      q: "« Je ne roule qu'à 45 km/h, ce n'est pas rapide. » Que faut-il en penser ?",
      choices: [
        "C'est vrai, à 45 km/h il n'y a aucun risque",
        "C'est faux : à 45 km/h une portière ou un piéton à quelques mètres devient un vrai danger",
        "C'est vrai tant qu'il n'y a pas de circulation",
        "C'est faux uniquement la nuit",
      ],
      answer: 1,
      explain: "La bonne allure n'est pas celle qui est autorisée, c'est celle qui te laisse ENCORE une solution. Plus tu vas vite, moins tu as de temps pour réagir à un imprévu proche.",
    },
    {
      q: "Ton téléphone vibre dans ta poche pendant que tu roules. Que fais-tu ?",
      choices: [
        "Je jette un œil rapide, ça ne prend qu'une seconde",
        "Je réponds au feu rouge suivant",
        "Je laisse sonner et, si vraiment nécessaire, je m'arrête dans un endroit sûr",
        "Je réponds en tenant le téléphone d'une main",
      ],
      answer: 2,
      explain: "Règle simple : JE CONDUIS → JE NE CONSULTE PAS MON TÉLÉPHONE. La route continue pendant les 2 secondes où tu regardes l'écran. Le message peut attendre, la route non.",
    },
    {
      q: "Tu as consommé un peu d'alcool à une fête. Tu te sens « bien ». Que peux-tu conduire ?",
      choices: [
        "Ton scooter si tu roules doucement",
        "Ton scooter uniquement sur trajet court",
        "Rien : tes capacités peuvent être altérées AVANT que tu t'en rendes compte",
        "N'importe quoi tant que tu es prudent",
      ],
      answer: 2,
      explain: "L'alcool et les substances psychoactives altèrent temps de réaction, attention, perception et évaluation du risque — souvent sans que tu le sentes. Règle : si tu n'es pas en état, tu ne conduis pas.",
    },
    {
      q: "Tes copains accélèrent devant toi et te font signe de suivre. Comment réagis-tu ?",
      choices: [
        "Je suis pour ne pas rester derrière",
        "Je force l'allure pour montrer que je suis capable",
        "Je garde MON allure : je roule à mon niveau, pas à celui du plus rapide",
        "Je double par la droite pour aller plus vite",
      ],
      answer: 2,
      explain: "Celui qui prend la décision est aussi celui qui en subira les conséquences. Un accident sous pression du groupe reste TON accident. Tu roules à ton niveau.",
    },
    {
      q: "Il commence à pleuvoir alors que tu circules. Qu'est-ce qui change ?",
      choices: [
        "Rien, un cyclomoteur c'est adapté à toutes les météos",
        "L'adhérence, la visibilité, la distance de freinage et le comportement des autres usagers",
        "Uniquement la visibilité",
        "Uniquement mon confort",
      ],
      answer: 1,
      explain: "La pluie modifie plusieurs paramètres à la fois. La bonne méthode : QU'EST-CE QUI CHANGE ? → QUEL EST LE RISQUE ? → QUELLE EST MA SOLUTION ? (ralentir, allumer les feux, augmenter les distances).",
    },
    {
      q: "Tu vas à l'école : à peine 800 mètres à faire. Comment t'équipes-tu ?",
      choices: [
        "Casque seul, c'est suffisant pour un trajet court",
        "Aucun équipement, tu vas très doucement",
        "Équipement complet (casque, gants, blouson, pantalon adapté, chaussures)",
        "Simplement une veste réfléchissante",
      ],
      answer: 2,
      explain: "L'accident ne te demande pas « tu vas loin ? ». La majorité des accidents surviennent sur des trajets habituels. Ton équipement doit être une routine, pas une exception.",
    },
    {
      q: "Un ami te propose de « débrider » ton scooter pour aller plus vite. Que faut-il en penser ?",
      choices: [
        "C'est une bonne idée, plus rapide = plus sûr",
        "C'est neutre, ça ne change rien",
        "C'est problématique : véhicule non conforme, assurance qui saute, comportement modifié, sanctions",
        "C'est autorisé si tu as le permis A2",
      ],
      answer: 2,
      explain: "Personnaliser (autocollants, esthétique) est possible. MODIFIER les caractéristiques réglementaires (kit, débridage) rend le véhicule non conforme : plus d'assurance, comportement imprévisible, sanctions.",
    },
    {
      q: "Tu es très fatigué, il pleut et tu n'as pas dormi. Que fais-tu pour rentrer ?",
      choices: [
        "Je prends mon scooter, un café me réveillera",
        "Je force la vigilance pendant le trajet",
        "J'active mon plan B : parent, transport en commun, attendre, dormir sur place si possible",
        "Je roule plus vite pour arriver avant de m'endormir",
      ],
      answer: 2,
      explain: "Renoncer à un trajet est une EXCELLENTE décision de conducteur. Ton plan B (parent, TC, attendre) fait partie intégrante de ta sécurité.",
    },
    {
      q: "Quelle affirmation résume le mieux la formation Sensibilisation ?",
      choices: [
        "Il suffit de savoir piloter parfaitement pour éviter tous les accidents",
        "Une seule mauvaise décision peut suffire à supprimer toutes les marges construites",
        "Le comportement des autres est le seul facteur de risque",
        "Un bon équipement protège de tout",
      ],
      answer: 1,
      explain: "Conduire, ce n'est pas seulement savoir utiliser un deux-roues. C'est savoir QUAND rouler, COMMENT rouler… et parfois savoir NE PAS rouler. Une seule mauvaise décision peut annuler toutes tes marges.",
    },
  ],
};

export default quiz;
